import { UntypedFormGroup } from '@angular/forms';
import { ApplianceDetailsAdditionalAppliancesFormField } from '../../models/appliance-details-additional-appliances/appliance-details-additional-appliances-form-field.enum';
import { ApplianceDetailsAdditionalAppliancesForm } from '../../models/appliance-details-additional-appliances/appliance-details-additional-appliances-form.interface';

export const mockApplianceDetailsAdditionalAppliancesForm: ApplianceDetailsAdditionalAppliancesForm =
  {
    [ApplianceDetailsAdditionalAppliancesFormField.AdditionalAppliances]:
      new UntypedFormGroup({}),
  };
